export default __webpack_public_path__ + "static/media/ProfessionalHistory.93ac8919.png";